import { jsx as _jsx } from "react/jsx-runtime";
import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import { Button } from '@rocketlane/ui';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { DateFromTo } from '../date-from-to';
export const ContentToRender = ({ startDate, dueDate, placeholder })=>{
    const today = moment();
    const tomorrow = moment().clone().add(1, 'day');
    if (!startDate && today.isSame(dueDate, 'day')) {
        return /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "today"
        });
    }
    if (!startDate && tomorrow.isSame(dueDate, 'day')) {
        return /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "tomorrow"
        });
    }
    if (startDate || dueDate) {
        return /*#__PURE__*/ _jsx(DateFromTo, {
            from: startDate,
            to: dueDate
        });
    }
    return placeholder || /*#__PURE__*/ _jsx(FormattedMessage, {
        id: "choose"
    });
};
export const DueDatePickerTrigger = ({ block, disabled, size, hasValue, placeholder, startDate, dueDate, onClick, hideIcon })=>/*#__PURE__*/ _jsx(Button, {
        className: block ? 'cp-w-full' : undefined,
        disabled: disabled,
        leftIcon: !hideIcon ? /*#__PURE__*/ _jsx(EventSchedule16, {}) : undefined,
        size: size === 'middle' ? 'medium' : size,
        variant: hasValue ? 'ghost' : 'link',
        type: "button",
        onClick: onClick,
        "data-cy": "choose.due.date",
        children: /*#__PURE__*/ _jsx(ContentToRender, {
            startDate: startDate,
            dueDate: dueDate,
            placeholder: placeholder
        })
    });
